import { managedKnowledgeRefSchema } from "@redotech/shopper-agent-knowledge-common/managed-knowledge-view";
import * as z from "zod";

/**
 * Removes any mix of corpora from the library in one call: merchant articles
 * retire, FAQ entries unlink — the FAQ article itself is never deleted.
 */
export const removeKnowledge = {
  name: "removeKnowledge" as const,
  input: z.object({ refs: z.array(managedKnowledgeRefSchema) }).strict(),
  output: z.object({
    /** Refs that were missing or already removed count as not removed. */
    removedCount: z.number(),
  }),
};
